import { Injectable } from '@angular/core';

function _window(): any {
  return window;
}

@Injectable()
export class WindowRefService {
  get nativeWindow(): any {
    return _window();
  }

  get document(): any {
    return this.nativeWindow.document;
  }

  get pageAppParams(): {
    isMobile?: boolean;
    vUid?: string;
    ymId?: string;
    openTimestamp?: number;
    debug: boolean;
  } {
    const w = _window();
    return {
      openTimestamp: w['adrum-start-time'],
      isMobile: w.app?.isMobile,
      vUid: w.app?.v_uid,
      ymId: w.app?.yandex_client_id,
      debug: w.app?.debug || false,
    };
  }
}
